import React, { useEffect, useState } from "react";
import {
  Card,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TablePagination,
  TableRow,
  Box,
  Chip,
} from "@material-ui/core";
import {
  Button,
  IconButton,
  InputBase,
  Paper,
  TextField,
  FormControl,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  useMediaQuery,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { useQuery } from "react-query";
import { EVENTS } from "src/api/axios";
import UserListHead from "src/components/user/UserListHead";
import useAxiosPrivate from "src/hooks/useAxiosPrivate";
import Stack from "@mui/material/Stack";
import { useSnackbar } from "notistack";
import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import EditPenIcon from "src/svgComponents/EditPenIcon";
import BinIcon from "src/svgComponents/BinIcon";
import CloseIcon from "@mui/icons-material/Close";
import { Form, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import { useTheme } from "@mui/material/styles";
import { useMutation } from "react-query";
import FormHelperText from "@mui/material/FormHelperText";
import SearchIcon from "src/svgComponents/SearchIcon";
import LoadingScreen from "src/components/LoadingScreen";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { fDateTime } from "src/utils/formatTime";
import ShowImage from "../common/ShowImage";
import { Autocomplete, LoadScript } from "@react-google-maps/api";
import InputAdornment from "@mui/material/InputAdornment";
import GoogleIcon from "src/svgComponents/GoogleIcon";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import AppTooltip from "src/components/common/AppTooltip";
import useStore from "src/contexts/AuthProvider";
import DefaultImage from "../../assets/images/event_default_image.png";
import { LoadingButton } from "@mui/lab";
import ButtonText from "src/components/common/ButtonText";

const _ = require("lodash");
const Event = () => {
  const [tableData, setTableData] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [order, setOrder] = useState("desc");
  const [orderBy, setOrderBy] = useState("createdAt");
  const axiosPrivate = useAxiosPrivate();
  const [openModal, setOpenModal] = useState(false);
  const [profilePic, setProfilePic] = useState("");
  const [imageName, setImageName] = useState("");
  const [showImage, setShowImage] = useState("");
  const [modelTitle, setmodelTitle] = useState("");
  const [filterName, setFilterName] = useState("");
  const [Id, setId] = useState("");
  const { enqueueSnackbar } = useSnackbar();
  const [deleteId, setdeleteId] = useState("");
  const [disable, setDisable] = useState(false);
  const [startTimeValue, setstartDateTime] = useState("");
  const [endTimeValue, setendDateTime] = useState("");
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const [loading, setLoding] = useState(true);
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [locationLat, setLocationLat] = useState();
  const [locationLng, setLocationLng] = useState();
  const [address, setAddress] = useState();
  const libraries = ["drawing", "places"];
  const permissionsData = useStore((state) => state.permissions);
  const [uploadedImage, setUploadedImage] = useState();
  const [flag, setFlag] = useState();
  const [buttonLoading, setButtonLoding] = useState(false);
  const googleMapKey = process.env.REACT_APP_GOOGLE_KEY;

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
      backgroundColor: "#ffffff",
    },
    "&:nth-of-type(even)": {
      background:
        "linear-gradient(0deg, rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0.6)), #F4F5F7",
    },
    // hide last border
    "& td, & th": {
      border: 0,
    },
  }));

  const TABLE_HEAD = [
    { id: "name", label: "Name", alignRight: false },
    { id: "image", label: "Image", alignRight: false },
    { id: "time", label: "Event Start Date & Time", alignRight: false },
    { id: "end_date", label: "Event End Date & Time", alignRight: false },
    { id: "city", label: "City", alignRight: false },
    { id: "detail", label: "Detail", alignRight: false },
    { id: "price", label: "Price", alignRight: false },
    { id: "discount", label: "Discount", alignRight: false },
    { id: "offerPrice", label: "New Price", alignRight: false },
    { id: "status", label: "Status", alignRight: false },
    { id: "action", label: "Action", alignRight: false },
  ];

  async function getEvents(page, filterName) {
    const response = await axiosPrivate.get(EVENTS.getEvents, {
      params: { page: page + 1, search: filterName, limit: rowsPerPage },
    });
    return response.data[0];
  }

  const { data: eventList, refetch } = useQuery(
    ["eventList", page, filterName],
    () => getEvents(page, filterName),
    { keepPreviousData: true }
  );

  useEffect(() => {
    if (eventList) {
      setTableData(eventList.data);
      setRowsPerPage(
        eventList?.metadata.length != 0 ? eventList?.metadata[0].limit : 10
      );
    }
    if (
      eventList?.metadata.length != 0 &&
      eventList?.metadata[0].hasMoreData == true
    ) {
      getEvents(page + 1);
    }
    setTimeout(() => {
      setLoding(false);
    }, 1000);
  }, [eventList]);

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    setTimeout(() => {
      refetch();
    }, 500);
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleFilterByName = (event) => {
    setFilterName(event.target.value.trim());
    setPage(0);
    getEvents(page, filterName);
    refetch();
  };
  const [autoComplete, setAutoComplete] = useState();

  const onAutoCompleteIsLoad = (inputAutoComplete) => {
    setAutoComplete(inputAutoComplete);
  };

  const onAutoCompletePlaceIsChanged = () => {
    // console.log("auto complete is changed");
    if (autoComplete !== null) {
      var place = autoComplete.getPlace();
      setAddress(place.formatted_address);
      setFieldValue("city", place.formatted_address);
      setLocationLat(place.geometry.location.lat());
      setLocationLng(place.geometry.location.lng());
    }
  };

  const completedSchema = Yup.object().shape({
    name: Yup.string()
      .min(2, "Name can set of between 2 and 50 characters!")
      .max(50, "Name can set of between 2 and 50 characters!")
      .required("Name is required"),
    price: Yup.number()
      .required("Price is required")
      .min(0, "Price must be greater than 1"),
    // .max(9999999, "Price must be less than 9999999"),
    offerPrice: Yup.number()
      .required("Offer price is required")
      .min(0, "Offer price must be greater than 1"),
    // .max(9999999, "Offer price must be less than 9999999"),
    city: Yup.string().required("Address is required"),
    start_date: Yup.string().required("Start date is required"),
    end_date: Yup.string().required("End date is required"),
    detail: Yup.string().required("Detail is required"),
  });

  const handleUploadImage = async () => {
    const formData = new FormData();
    formData.append("image", uploadedImage);
    const imageData = await axiosPrivate
      .post(EVENTS.uploadImage, formData)
      .catch((e) => {
        setButtonLoding(false);
        enqueueSnackbar(e?.response?.data?.message, {
          variant: "error",
          anchorOrigin: { vertical: "top", horizontal: "right" },
          autoHideDuration: 2000,
        });
      });
    setImageName(imageData?.data?.file_name);
    setFieldValue("image", imageData?.data?.file_name);
    return imageData?.data?.file_name;
  };

  const formik = useFormik({
    initialValues: {
      name: "",
      city: "",
      detail: "",
      start_date: "",
      end_date: "",
      date: "",
      price: "",
      offerPrice: "",
      latitude: "",
      longitude: "",
      image: "",
    },
    validationSchema: completedSchema,
    onSubmit: async (values, { resetForm, setFieldError, setSubmitting }) => {
      if (startTimeValue === null || endTimeValue === null) {
        enqueueSnackbar("Please select start-date & end-date", {
          variant: "error",
          anchorOrigin: { vertical: "top", horizontal: "right" },
          autoHideDuration: 2000,
        });
      } else {
        let image_name = "";
        if (!imageName) {
          if (flag === "asd") {
            image_name = await handleUploadImage();
          }
        } else {
          image_name = imageName;
        }
        if (image_name) {
          setButtonLoding(true);
        }
        const informationObj = {
          latitude: locationLat,
          longitude: locationLng,
          // date: moment(dateTimeValue?.$d || dateTimeValue).format('YYYY-MM-DD'),
          start_date: moment(startTimeValue?.$d || startTimeValue).toISOString(),
          end_date: moment(endTimeValue?.$d || endTimeValue).toISOString(),
          name: values.name.trim(),
          city: address,
          detail: values.detail,
          price: values.price,
          discount: values.discount,
          offerPrice: values.offerPrice,
          image: image_name,
        };

        if (Id == "") {
          await eventAdd(informationObj);
        } else {
          await eventUpdate(informationObj);
        }
        resetForm();
        setSubmitting(false);
      }
    },
  });

  const { mutateAsync: eventAdd } = useMutation(
    async (data) => {
      return await axiosPrivate.post(EVENTS.addEvent, data);
    },
    {
      onSuccess: ({ data }) => {
        enqueueSnackbar(data.message, {
          variant: "success",
          anchorOrigin: { vertical: "top", horizontal: "right" },
          autoHideDuration: 2000,
        });
        handleCloseModal();
        refetch();
        setButtonLoding(false);
      },
      onError: (error) => {
        setButtonLoding(false);
        const errorData = error.response.data.errors;
        if (error.response?.data?.message) {
          enqueueSnackbar(error.response?.data?.message, {
            variant: "error",
            anchorOrigin: { vertical: "top", horizontal: "right" },
            autoHideDuration: 2000,
          });
        }
        Object.keys(errorData).forEach((key) => {
          if (key === "name") {
            setFieldError("name", errorData[key]);
          } else if (key === "date") {
            setFieldError(key, errorData[key]);
          } else if (key === "time") {
            setFieldError(key, errorData[key]);
          } else if (key === "city") {
            setFieldError(key, errorData[key]);
          } else if (key === "detail") {
            setFieldError(key, errorData[key]);
          } else if (key === "price") {
            setFieldError(key, errorData[key]);
          } else if (key === "offerPrice") {
            setFieldError(key, errorData[key]);
          } else if (key === "image") {
            setFieldError(key, errorData[key]);
          } else {
            setFieldError(key, errorData[key]);
          }
        });
      },
    }
  );

  const { mutateAsync: eventUpdate } = useMutation(
    async (data) => {
      return await axiosPrivate.patch(EVENTS.eventUpdate + "/" + Id, data);
    },
    {
      onSuccess: ({ data }) => {
        refetch();
        enqueueSnackbar(data.message, {
          variant: "success",
          anchorOrigin: { vertical: "top", horizontal: "right" },
          autoHideDuration: 2000,
        });
        handleCloseModal();
        setButtonLoding(false);
      },
      onError: (error) => {
        setButtonLoding(false);
        const errorData = error.response.data.errors;
        if (error.response?.data?.message) {
          enqueueSnackbar(error.response?.data?.message, {
            variant: "error",
            anchorOrigin: { vertical: "top", horizontal: "right" },
            autoHideDuration: 2000,
          });
        }
        Object.keys(errorData).forEach((key) => {
          if (key === "name") {
            setFieldError("name", errorData[key]);
          } else {
            setFieldError(key, errorData[key]);
          }
        });
      },
    }
  );

  function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }

  function getComparator(order, orderBy) {
    return order === "desc"
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }
  function applySortFilter(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });

    return stabilizedThis.map((el) => el[0]);
  }

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  // const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - categoryList?.metadata[0].total) : 0;

  const filteredUsers = applySortFilter(
    tableData,
    getComparator(order, orderBy)
  );

  const handleClose = () => {
    setOpen(false);
    setShowImage("");
  };

  const deleteEvent = async () => {
    const response = await axiosPrivate.delete(
      EVENTS.deleteEvent + "/" + deleteId
    );
    if (response.status == 200) {
      enqueueSnackbar(response.data.message, {
        variant: "success",
        anchorOrigin: { vertical: "top", horizontal: "right" },
        autoHideDuration: 2000,
      });
    } else {
      enqueueSnackbar("Something went wrong", {
        variant: "error",
        anchorOrigin: { vertical: "top", horizontal: "right" },
        autoHideDuration: 2000,
      });
    }
    refetch();
    handleClose();
  };

  const handleOpenModalAdd = () => {
    setFieldValue("name", "");
    setFieldValue("detail", "");
    setFieldValue("city", "");
    setFieldValue("date", "");
    setstartDateTime("");
    setendDateTime("");
    setFieldValue("price", "");
    setFieldValue("offerPrice", "");
    setFieldValue("discount", "");
    setFieldValue("latitude", "");
    setFieldValue("longitude", "");
    setShowImage("");
    setProfilePic("");
    setImageName("");
    setLocationLat("");
    setLocationLng("");
    setAddress("");
    setFlag("");
    setId("");
    setmodelTitle("Event Add");
    setDisable(false);
    setOpenModal(true);
  };

  const handleOpenModalUpdate = (row) => {
    if (row.discount === undefined) {
      setFieldValue("offerPrice", row.price);
    } else {
      setFieldValue("offerPrice", row.offerPrice);
    }
    setFieldValue("name", row.name);
    setFieldValue("city", row.city);
    setFieldValue("detail", row.detail);
    setstartDateTime(new Date(row.time));
    setendDateTime(new Date(row.end_date));
    setFieldValue("price", row.price);
    setFieldValue("image", row.image);
    setFieldValue("discount", row.discount);
    setAutoComplete(row.city);
    setAddress(row.city);
    setShowImage(row.image);
    setImageName(row.image);
    setId(row._id);
    setLocationLat(row.latitude);
    setLocationLng(row.longitude);
    setmodelTitle("Event Update");
    setDisable(true);
    setOpenModal(true);
  };

  const handleClickOpen = (categoryId, categoryType) => {
    setdeleteId(categoryId);
    setOpen(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    resetForm();
  };

  const handleProfilePicOnChange = async (ev) => {
    if (ev.type.includes("image")) {
      setUploadedImage(ev);
      let userImgSrc = URL.createObjectURL(ev);
      setProfilePic(userImgSrc);
      setImageName("");
    } else {
      enqueueSnackbar("Please select only jpeg, jpg, png, webp file", {
        variant: "error",
        anchorOrigin: { vertical: "top", horizontal: "right" },
        autoHideDuration: 2000,
      });
    }
  };

  const {
    errors,
    touched,
    setFieldValue,
    handleSubmit,
    setFieldError,
    getFieldProps,
    resetForm,
  } = formik;

  const changeStatus = async (id) => {
    const response = await axiosPrivate.put(
      EVENTS.changeEventStatus + "/" + id
    );
    if (response?.data?.message) {
      enqueueSnackbar(response?.data?.message, {
        variant: "success",
        anchorOrigin: { vertical: "top", horizontal: "right" },
        autoHideDuration: 2000,
      });
    }
    refetch();
  };

  const removeImage = () => {
    setProfilePic("");
    setImageName("");
    setShowImage("");
  };
  const setDiscount = (e) => {
    let price = getFieldProps("price");
    let discount = e.target.value;
    setFieldValue("discount", discount);
    let discountInRs = (price.value * discount) / 100;
    let offerPrice = price.value - discountInRs;
    setFieldValue("offerPrice", offerPrice);
  };

  const setPrice = (e) => {
    let discount = getFieldProps("discount");
    let price = e.target.value;
    setFieldValue("price", price);
    let discountInRs = (price * discount.value) / 100;
    let offerPrice = price - discountInRs;
    if (discount.value) {
      setFieldValue("offerPrice", offerPrice);
    } else {
      setFieldValue("offerPrice", price);
    }
  };

  const handlestartDateTimes = (e) => {
    setstartDateTime(e);
    setFieldValue("start_date", e);
  };
  const handleendDateTimes = (e) => {
    setendDateTime(e);
    setFieldValue("end_date", e);
  };

  return (
    <>
      <LoadingScreen loading={loading} />
      <div className="dashboard_header mb-4">
        <h4 className="app_text_20_semibold mb-0 d-flex align-items-center">
          Event
        </h4>
        <Box className="d-flex align-items-center">
          <Paper
            component="form"
            className="dashboard_searchbox"
            sx={{ minWidth: "380px" }}
          >
            <IconButton>
              <SearchIcon />
            </IconButton>
            <InputBase
              fullWidth
              sx={{ flex: 1 }}
              placeholder="Search Event..."
              onChange={(e) => handleFilterByName(e)}
              onKeyPress={(e) => {
                e.key === "Enter" && e.preventDefault();
              }}
            />
          </Paper>
          <Stack
            direction={"row"}
            className="d-flex align-items-center ms-lg-4 ms-2"
            spacing={2}
          >
            {permissionsData?.events?.substring(1, 2) == "1" ? (
              <AppTooltip title="Add Event" placement="bottom">
                <ButtonText text={'Create Event'} onClickBtn={() => handleOpenModalAdd()} />
              </AppTooltip>
            ) : (
              ""
            )}
          </Stack>
        </Box>
      </div>
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title" className="m-auto">
          {"Are you sure you want to delete?"}
        </DialogTitle>
        <DialogContent></DialogContent>
        <DialogActions className="m-auto">
          <Button
            className="theme_button_view"
            variant="contained"
            autoFocus
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Button
            className="theme_button"
            variant="contained"
            onClick={() => deleteEvent()}
            autoFocus
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
      <Card>
        <TableContainer>
          <Table>
            <UserListHead
              headLabel={TABLE_HEAD}
              rowCount={eventList?.data?.length}
              onRequestSort={handleRequestSort}
            />
            {filteredUsers?.length > 0 ? (
              <TableBody>
                {filteredUsers.map((row) => {
                  return (
                    <StyledTableRow key={row._id}>
                      <TableCell component="th" scope="row">
                        {row.name}
                      </TableCell>
                      <TableCell component="th" scope="row">
                        <img
                          src={
                            row.image
                              ? process.env.REACT_APP_PROFILE_URL +
                              "eventImage/" +
                              row.image
                              : DefaultImage
                          }
                          height="53px"
                          width="73px"
                          alt="profile"
                        />
                      </TableCell>
                      {/* <TableCell align="left" style={{ whiteSpace: 'normal' , maxWidth: '150px' }} component="th"><span className="d-flex text-nowrap">{moment.utc(row.time).local().format("DD MMM YYYY h:mm A")}</span></TableCell> */}
                      <TableCell
                        align="left"
                        style={{ whiteSpace: "normal", maxWidth: "150px" }}
                        component="th"
                      >
                        <span className="d-flex text-nowrap">
                          {moment(row.time)
                            .format("DD MMM YYYY h:mm A")
                            .toLocaleString()}
                        </span>
                      </TableCell>
                      <TableCell
                        align="left"
                        style={{ whiteSpace: "normal", maxWidth: "150px" }}
                        component="th"
                      >
                        <span className="d-flex text-nowrap">
                          {moment(row.end_date)
                            .format("DD MMM YYYY h:mm A")
                            .toLocaleString()}
                        </span>
                      </TableCell>
                      <TableCell
                        align="left"
                        style={{ whiteSpace: "normal", maxWidth: "150px" }}
                        component="th"
                      >
                        {" "}
                        {row?.city}
                      </TableCell>
                      <TableCell
                        align="left"
                        style={{ whiteSpace: "normal", maxWidth: "150px" }}
                        component="th"
                      >
                        {" "}
                        {row?.detail.substring(0, 38) +
                          (row?.detail.length >= 38 ? " ...." : "")}
                      </TableCell>
                      <TableCell align="left">
                        {" "}
                        £{row?.price.toFixed(2) ?? "0.00"}
                      </TableCell>
                      <TableCell align="left">
                        {" "}
                        {row.discount ? row.discount + "%" : "-"}
                      </TableCell>
                      <TableCell align="left">
                        {" "}
                        £{row?.offerPrice?.toFixed(2) ?? "0.00"}
                      </TableCell>
                      {/* <TableCell align="left"> {moment(row.createdAt).format("MMM DD YYYY h:mm A")}</TableCell> */}
                      <TableCell>
                        <Stack direction="row" spacing={3}>
                          {row.status == 1 ? (
                            <Chip
                              variant="contained"
                              label="Enable"
                              className="app_status_chip accepted"
                              onClick={() => changeStatus(row._id)}
                            />
                          ) : (
                            <Chip
                              variant="contained"
                              className="app_status_chip invalid"
                              label="Disable"
                              onClick={() => changeStatus(row._id)}
                            />
                          )}
                        </Stack>
                      </TableCell>
                      <TableCell>
                        <Stack direction="row" spacing={3}>
                          {permissionsData?.events?.substring(3, 4) == "1" ? (
                            <AppTooltip title="Edit Event" placement="bottom">
                              <Button
                                sx={{ "&:hover": { bgcolor: "transparent" } }}
                                onClick={() => handleOpenModalUpdate(row)}
                                variant="text"
                                className="user_list_row_btn"
                              >
                                <EditPenIcon />
                              </Button>
                            </AppTooltip>
                          ) : (
                            ""
                          )}
                          {permissionsData?.events?.substring(2, 3) == "1" ? (
                            <AppTooltip title="Delete Event" placement="bottom">
                              <Button
                                variant="text"
                                className="user_list_row_btn"
                                onClick={() => handleClickOpen(row._id, "main")}
                              >
                                <BinIcon />
                              </Button>
                            </AppTooltip>
                          ) : (
                            ""
                          )}
                        </Stack>
                      </TableCell>
                    </StyledTableRow>
                  );
                })}
              </TableBody>
            ) : (
              <TableBody>
                <TableRow>
                  <TableCell align="center" colSpan={9} sx={{ py: 5 }}>
                    <span className="app_text_16_semibold">No Data Found</span>
                  </TableCell>
                </TableRow>
              </TableBody>
            )}
          </Table>
        </TableContainer>
        <TablePagination
          component="div"
          rowsPerPageOptions={[10, 20, 50, 100]}
          count={
            eventList?.metadata.length != 0 ? eventList?.metadata[0].total : 0
          }
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Card>
      <Dialog
        open={openModal}
        onClose={handleCloseModal}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <DialogTitle>
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <h4>{modelTitle}</h4>
            <Button
              className="dashboard_light_bg_icon_btn"
              onClick={handleCloseModal}
              aria-label="delete"
            >
              <CloseIcon style={{ color: "#fff" }} />
            </Button>
          </Box>
        </DialogTitle>
        <DialogContent className="custom_form_mui pt-2">
          <FormikProvider value={formik}>
            <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-lg-6 ">
                  <div className="form-group mb-3">
                    <TextField
                      label="Name"
                      name="name"
                      autoComplete="off"
                      fullWidth
                      variant="outlined"
                      {...getFieldProps("name")}
                      error={Boolean(touched.name && errors.name)}
                      helperText={touched.name && errors.name}
                    />
                  </div>
                </div>
                <div className="col-lg-6 ">
                  <div className="form-group mb-3">
                    <LoadScript
                      googleMapsApiKey={googleMapKey}
                      libraries={libraries}
                    >
                      <Autocomplete
                        onLoad={onAutoCompleteIsLoad}
                        onPlaceChanged={onAutoCompletePlaceIsChanged}
                      >
                        <TextField
                          label="Address"
                          type="text"
                          autoComplete="off"
                          fullWidth
                          variant="outlined"
                          {...getFieldProps("city")}
                          placeholder="Search address"
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <GoogleIcon size={36} />
                              </InputAdornment>
                            ),
                          }}
                          error={Boolean(touched.city && errors.city)}
                          helperText={touched.city && errors.city}
                        />
                      </Autocomplete>
                    </LoadScript>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-4">
                  <div className="form-group mb-4">
                    <TextField
                      label="Price"
                      name="price"
                      type="number"
                      autoComplete="off"
                      fullWidth
                      variant="outlined"
                      {...getFieldProps("price")}
                      onChange={(e) => setPrice(e)}
                      error={Boolean(touched.price && errors.price)}
                      helperText={touched.price && errors.price}
                    />
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="form-group mb-4">
                    <TextField
                      label="Discount"
                      name="discount"
                      type="number"
                      autoComplete="off"
                      fullWidth
                      variant="outlined"
                      {...getFieldProps("discount")}
                      onChange={(e) => setDiscount(e)}
                      error={Boolean(touched.discount && errors.discount)}
                      helperText={touched.discount && errors.discount}
                    />
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="form-group mb-4">
                    <TextField
                      label="Offer Price"
                      name="offerPrice"
                      type="number"
                      autoComplete="off"
                      fullWidth
                      variant="outlined"
                      {...getFieldProps("offerPrice")}
                      disabled
                      error={Boolean(touched.offerPrice && errors.offerPrice)}
                      helperText={touched.offerPrice && errors.offerPrice}
                    />
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="form-group mb-4">
                    <FormControl fullWidth>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DateTimePicker
                          label="Start Datetime"
                          onChange={(e) => handlestartDateTimes(e)}
                          value={startTimeValue}
                          renderInput={(props) => (
                            <TextField
                              {...props}
                              name="start_date"
                              {...getFieldProps("start_date")}
                              error={Boolean(touched.start_date && errors.start_date)}
                              helperText={touched.start_date && errors.start_date}
                            />
                          )}
                        />
                      </LocalizationProvider>
                    </FormControl>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="form-group mb-4">
                    <FormControl fullWidth>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DateTimePicker
                          label="End Datetime"
                          onChange={(e) => handleendDateTimes(e)}
                          value={endTimeValue}
                          renderInput={(props) => (
                            <TextField
                              {...props}
                              name="end_date"
                              {...getFieldProps("end_date")}
                              error={Boolean(touched.end_date && errors.end_date)}
                              helperText={touched.end_date && errors.end_date}
                            />
                          )}
                        />
                      </LocalizationProvider>
                    </FormControl>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-12">
                  <div className="form-group mb-4">
                    <TextField
                      sx={{
                        "& .MuiInputBase-input.MuiOutlinedInput-input": {
                          minHeight: "3.5rem",
                        },
                      }}
                      label="Detail"
                      multiline
                      name="Detail"
                      autoComplete="off"
                      fullWidth
                      {...getFieldProps("detail")}
                      error={Boolean(touched.detail && errors.detail)}
                      helperText={touched.detail && errors.detail}
                    />
                  </div>
                </div>
                <div className="col-lg-6">
                  <ShowImage
                    modalId={Id}
                    profilePic={profilePic}
                    showImage={showImage}
                    folderName="eventImage/"
                    onRemoveFunc={() => {
                      removeImage();
                    }}
                  />
                  <Button
                    className="my-4 text-white app_bg_primary app_text_14_500 p-2"
                    variant="contained"
                    component="label"
                    style={{ borderRadius: 5 }}
                  >
                    {Id ? "Change image" : "Select Image"}
                    <input
                      hidden
                      accept="image/*"
                      onChange={(event) => {
                        const files = event.target.files[0];
                        if (files !== undefined) {
                          setFlag("asd");
                          handleProfilePicOnChange(files);
                        }
                      }}
                      type="file"
                    />
                  </Button>
                  <FormHelperText error>{errors.image}</FormHelperText>
                </div>
              </div>
              <div className="col">
                <div className="col-md-8 m-auto">
                  <LoadingButton
                    type="submit"
                    fullWidth
                    className="my-3 text-lowercase text-white app_bg_primary app_text_16_semibold app_btn_lg"
                    loading={buttonLoading}
                    loadingPosition="end"
                    variant="contained"
                  >
                    submit
                  </LoadingButton>
                </div>
              </div>
            </Form>
          </FormikProvider>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default Event;
